import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { GcvAdminApi } from 'api';
import { LICENSES_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries';
import { getComplianceStore } from 'stores/ComplianceStore';

export function useLicenses({ shouldNotifyOnChange = true }: { shouldNotifyOnChange?: boolean } = {}) {
  const gcvAdminApi = new GcvAdminApi();
  const complianceStore = getComplianceStore();
  const { user } = useUser();

  const { data: licensesData, isLoading: isLoadingLicenses } = useQuery({
    enabled: !!user?.id,
    queryKey: [LICENSES_KEY],
    queryFn: () => gcvAdminApi.getAllLicenseData(),
    ...(!shouldNotifyOnChange && { notifyOnChangeProps: [] })
  });

  useEffect(() => {
    if (licensesData && Object.keys(licensesData).length) {
      complianceStore.setLicenseDataMap(licensesData);
    }
  }, [licensesData]);

  return { licensesData, isLoadingLicenses };
}
